import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { QUERY_FETCH_USER_DOWNLOADED_RESOURCES } from '@edwin-group/people-graphql';
import type { ResourceHubItem } from '@/pages/resource-hub/shared/types';

interface FetchUserDownloadedResourcesResponse {
  fetchUserDownloadedResources: ResourceHubItem[] | null;
}

export const useDownloadedResources = (limit = 9) => {
  const { data, loading, error } = useQuery<FetchUserDownloadedResourcesResponse>(
    QUERY_FETCH_USER_DOWNLOADED_RESOURCES,
    {
      variables: { limit },
      fetchPolicy: 'cache-and-network',
    },
  );

  const resources = useMemo(() => {
    return data?.fetchUserDownloadedResources ?? [];
  }, [data?.fetchUserDownloadedResources]);

  return {
    resources,
    loading,
    error,
    hasResources: resources.length > 0,
  };
};
